import {
  Avatar,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import PersonIcon from "@material-ui/icons/Person";
import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import AccordionNav from "../../components/common/AccordionNav";
import Dialog from "../../components/common/Dialog";
import EntryEvent from "../../components/EntryEvent/EntryEvent";
import Scan from "../../components/Scan/Scan";
import UserContext from "../../context/user-context";
import useShowImage from "../../hooks/useShowImage";
import { useStore } from "../../hooks/useStore";
import { useTranslation } from "../../hooks/useTranslation";
import { CompanionType } from "../../passapp-sdk/models/CompanionOption";
import { dataReset } from "../../redux/actions/dataAction";
import {
  addUserCompanion,
  deleteUserCompanion,
} from "../../store/actions/userAction";
import {
  AuthorizationType,
  Config,
  IAuthorization,
  ISearchUser,
} from "../../store/types/userTypes";
import { companionOptions } from "../../utils/Items";
import { EntrantTabIndex } from "../../utils/tabIndex";
import ManualSearchForm from "../ManualSearchForm/ManualSearchForm";
import CompanionOption from "./CompanionOption/CompanionOption";
import { useStyles } from "./CompanionsStyles";
import useValidation from "../../hooks/useValidation";

const Companions = () => {
  const classes = useStyles();
  const { state, dispatch } = useContext(UserContext);
  const globalDispatch = useDispatch();
  const showImage = useShowImage();
  const [openSearchDialog, setOpenSearchDialog] = useState(false);
  const [openScanDialog, setOpenScanDialog] = useState(false);
  const { dataStore } = useStore();
  const { t, BundleKey } = useTranslation();
  const { isLoadUser } = useValidation();
  const [openCompanionDialog, setOpenCompanionDialog] = useState(false);
  const [openWarnDialog, setOpenWarnDialog] = useState(false);
  const [openUserIsAlreadyUploadedDialog, setOpenUserIsAlreadyUploadedDialog] =
    useState(false);
  const [search, setSearch] = useState<{
    search: ISearchUser;
    config: Config;
  } | null>(null);

  const openDialogSearch = () => {
    if (isMarkAuthorization()) setOpenSearchDialog(true);
    else setOpenWarnDialog(true);
  };

  const getAuthorizationTransform = () => {
    let authorizations: IAuthorization[] = [];
    state.authorizations.forEach((item) => {
      if (item.mark) {
        let authorization = { ...item };
        authorization.type = AuthorizationType.current;
        authorization.mark = false;
        authorization.authorization = {
          ...authorization.authorization,
          type: "resident",
        };
        authorizations.push(authorization);
      }
    });
    return authorizations;
  };

  const submitDialogSearch = (dni: string, countryCode: string) => {
    isLoadUser({ dni, countryCode }).then((isLoad) => {
      if (isLoad) {
        setOpenSearchDialog(false);
        setOpenUserIsAlreadyUploadedDialog(true);
      } else {
        setSearch({
          search: { dni, countryCode },
          config: {
            companion: true,
            userRequested: state.id,
            userAddon: {
              authorizations: getAuthorizationTransform(),
            },
          },
        });
        setOpenSearchDialog(false);
        setOpenCompanionDialog(true);
      }
    });
  };

  const handleSearchClose = () => {
    setOpenSearchDialog(false);
  };

  const closeDialogCompanion = () => {
    setOpenCompanionDialog(false);
  };

  const openDialogScan = () => {
    if (isMarkAuthorization()) setOpenScanDialog(true);
    else setOpenWarnDialog(true);
  };

  const closeDialogScan = () => {
    setOpenScanDialog(false);
  };

  const submitDialogScan = (result: ISearchUser) => {
    isLoadUser(result).then((isLoad) => {
      if (isLoad) {
        setOpenScanDialog(false);
        setOpenUserIsAlreadyUploadedDialog(true);
      } else {
        setSearch({
          search: result,
          config: {
            companion: true,
            userRequested: state.id,
            userAddon: {
              authorizations: getAuthorizationTransform(),
            },
          },
        });
        setOpenScanDialog(false);
        setOpenCompanionDialog(true);
      }
    });
  };

  const deleteCompanion = (id: string) => {
    dispatch(deleteUserCompanion(id));
  };

  const isMarkAuthorization = () => {
    return state.authorizations.some((item) => item.mark === true);
  };

  const closeDialogWarn = () => {
    setOpenWarnDialog(false);
  };

  const closeDialogUserIsAlreadyUploaded = () => {
    setOpenUserIsAlreadyUploadedDialog(false);
  };

  useEffect(() => {
    if (dataStore.findCompanion === "cancel") {
      closeDialogCompanion();
      globalDispatch(dataReset());
    } else {
      if (
        dataStore.findCompanion &&
        dataStore.findCompanion.config?.userRequested === state.id
      ) {
        dispatch(addUserCompanion(dataStore.findCompanion));
        closeDialogCompanion();
        globalDispatch(dataReset());
      }
    }
  }, [dataStore.findCompanion]);

  return (
    <AccordionNav title={t(BundleKey.DETAIL_COMPATION_TITLE)} expanded={true}>
      <Grid container spacing={2}>
        {state.config?.eventType === "in" ? (
          <Grid item xs={12}>
            <Grid
              container
              direction="row"
              justifyContent="space-evenly"
              alignItems="center"
            >
              {companionOptions.map((item, index) => (
                <Grid item key={index}>
                  <CompanionOption
                    title={t(item.bundleTitle)}
                    id={item.id}
                    iconUrl={item.iconUrl}
                    tabIndex={item.tabIndex}
                    autoFocus={index === 0}
                    action={
                      CompanionType.MANUAL_ENTRY === item.id
                        ? openDialogSearch
                        : openDialogScan
                    }
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        ) : null}
        <Grid item xs={12}>
          <Grid
            container
            direction="row"
            justifyContent="space-evenly"
            alignItems="center"
          >
            {state.companions?.length > 0 ? (
              <Grid item>
                <Typography variant="h6" className={classes.title}>
                  {t(BundleKey.DETAIL_COMPATION_TITLE)}
                </Typography>
                <List component="nav" aria-label="main mailbox folders">
                  {state.companions.map((companion, index) => (
                    <ListItem key={index} button disabled={companion.isExit}>
                      <ListItemAvatar>
                        <Avatar>
                          {companion.facePhoto ? (
                            <img
                              className={classes.profile}
                              src={showImage(companion.facePhoto)}
                              alt="imagen de perfil"
                            />
                          ) : (
                            <PersonIcon />
                          )}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={`${companion.firstname} ${companion.lastname} - ${companion.dni}`}
                      />
                      {state.config?.eventType === "in" ? (
                        <ListItemSecondaryAction>
                          <IconButton
                            edge="end"
                            aria-label="delete"
                            onClick={() => deleteCompanion(companion.id)}
                            tabIndex={EntrantTabIndex.deleteCompanion}
                          >
                            <CloseIcon className={classes.deleteButton} />
                          </IconButton>
                        </ListItemSecondaryAction>
                      ) : null}
                    </ListItem>
                  ))}
                </List>
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        <Dialog open={openSearchDialog} onClose={handleSearchClose}>
          <ManualSearchForm
            onSubmit={submitDialogSearch}
            onCancel={handleSearchClose}
          />
        </Dialog>
        <Dialog
          open={openScanDialog}
          onClose={closeDialogScan}
          fullScreen
          title={t(BundleKey.DETAIL_COMPATION_SCAN)}
        >
          <Scan onScan={submitDialogScan} />
        </Dialog>
        <Dialog
          open={openCompanionDialog}
          fullScreen
          onClose={closeDialogCompanion}
          title={t(BundleKey.DETAIL_COMPATION_TITLE)}
        >
          {search ? (
            <EntryEvent search={search.search} config={search.config} />
          ) : null}
        </Dialog>
        <Dialog
          open={openWarnDialog}
          onClose={closeDialogWarn}
          title={t(BundleKey.DIALOG_FIELDMISSING_TITLE)}
          labelYes={t(BundleKey.ACTION_ACCEPT)}
        >
          <span>{t(BundleKey.ERROR_PASS_MUST)}</span>
        </Dialog>
        <Dialog
          open={openUserIsAlreadyUploadedDialog}
          onClose={closeDialogUserIsAlreadyUploaded}
          labelYes={t(BundleKey.ACTION_ACCEPT)}
        >
          {t(BundleKey.DIALOG_COMPANION_ALREADYLOADED)}
        </Dialog>
      </Grid>
    </AccordionNav>
  );
};

export default Companions;
